// extracted by mini-css-extract-plugin
export default {"headerButton":"iVhgy5dLDXQV8AXw9NFQ","title":"vcENtm1iEitkQaNnoo_i","content":"Cu4BlqkQUoYiOLQDXye2"};